import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';

import { LocalizedNavLink } from '@/shared/ui';

import useNavItems from '../../hooks/useNavItems';

interface IProps {
  /** Вызывается после выбора пункта — drawer по нему закрывается. */
  onNavigate?: () => void;
}

/** Разделы кабинета списком с иконками на тёмной подложке drawer. */
const NavMenu: React.FC<IProps> = ({ onNavigate }) => {
  const { t } = useTranslation();
  const { items, activeCode } = useNavItems();

  return (
    <nav aria-label={t('layout.nav.label')}>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={activeCode ? [activeCode] : []}
        onClick={onNavigate}
        items={items.map(({ code, label, route, icon: Icon }) => ({
          key: code,
          icon: <Icon />,
          label: <LocalizedNavLink to={route}>{label}</LocalizedNavLink>
        }))}
      />
    </nav>
  );
};

export default NavMenu;
